import { combineReducers } from "redux";

// Import custom components
import productReducer from "./products";
import searchedProductsArrayReducer from "./searchedProducts";
import searchedProductReducer from "./searchedProductDetail";
import cartReducer from "./cart";
import filtersReducer from "./filters";
import wishlistReducer from "./wishlist";
import compareReducer from "./compare";
import setCurrentUserReducer from "./currentUser";
import setOrderReducer from "./orders";
import setBookingRequestReducer from "./bookingRequest";
import shipForMeListReducers from "./shipForMeList";
import setNoticesReducer from "./notices";

const rootReducer = combineReducers({
  user: setCurrentUserReducer,
  bookingRequests: setBookingRequestReducer,
  data: productReducer,
  cartList: cartReducer,
  filters: filtersReducer,
  wishlist: wishlistReducer,
  compare: compareReducer,
  orders: setOrderReducer,
  searchedProducts: searchedProductsArrayReducer,
  singleProduct: searchedProductReducer,
  shipForMeList: shipForMeListReducers,
  notices: setNoticesReducer,
});

export default rootReducer;
